import { Component, Input, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { ListDataService } from "src/app/services/list-data.service";
import { UserItem } from "../../models/UserItem";
import { SearchParamsModel } from "../models/search-params-model";
import { StorageService } from "../services/storage.service";
import { ScheduleDataService } from "src/app/services/schedule-data.service";
import { ScheduleParameters } from "src/app/models/ScheduleParameters";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { forkJoin, of } from "rxjs";
import { AlertTruckerFilteredTruckersContactInfo } from "src/app/models/AlertTruckerFilteredTruckersInfo";
import { FilteredTruckersInfo } from "src/app/models/FilteredTruckersInfo";
import { AlertParameters } from "src/app/models/AlertParameters";
import { Schedule } from "src/app/models/Schedule";
import { MessageService } from "src/app/services/message.service";
import { UserDataService } from "../../services/user-data.service";

@Component({
    selector: "app-alert-truckers-filter",
    templateUrl: "alert-truckers-filter.component.html",
    styleUrls: ["alert-truckers-filter.component.css"],
    standalone: false
})
export class AlertTruckersFilterComponent implements OnInit {
    @Input() alertTruckerFilterModalId = "alertTruckerFilterModalId";
    isMobile = true; // Toggle for mobile view
    isOpen = false; // Toggle dropdown open/close  
    selectedValues: string[] = []; // Store selected values
    storedDataFromLS: SearchParamsModel;
    @ViewChild("closeButton") closeButton;
    userArray: UserItem[];
    errorMessage: any;
    isShowSubject: boolean;
    messageMaxLength = 480;
    emailForm: FormGroup;
    truckerArray: any;
    emailArray: any;
    phoneArray: any;
    manuallyBCCEnteredEmails: string[] = [];
    @Input() dispatchId: number;
    @Input() scheduleParms: ScheduleParameters;
    schedule: Schedule;
    response: { data: string; status: string; };
    truckers: { customerId: number; truckerName: string; mainContact: string; phone: string; email: string; isTruckerSelected: boolean; whetherToConsiderEmail: boolean; isTruckerAdded: boolean; whetherToConsiderPhone: boolean; }[];
    selectAll: false;
    @Input() alertParameters: AlertParameters = new AlertParameters();
    bccValid: boolean;
    filteredUserArray: UserItem[];
    searchText: any;
    constructor(
        private _listDataService: ListDataService,
        private _storageService: StorageService,
        private _messageService: MessageService,
        private formBuilder: FormBuilder,
        private _scheduleDataService: ScheduleDataService,
        private _userDataService: UserDataService
    ) {
    }

    ngOnInit(): void {
    }

    getAllUsers() {
        this._userDataService.getUsers(this.storedDataFromLS.locCode, true).subscribe({
            next: (data) => {
                this.userArray = data;
                this.filteredUserArray = [...this.userArray];
            },
            error: (err) => (this.errorMessage = err),
        });
    }

    filterUsers(event: any) {
        const searchText = (event.target as HTMLInputElement).value;
        this.filteredUserArray = this.userArray.filter(user =>
            user.userName.toLowerCase().includes(searchText.toLowerCase())
        );
    }

    toggleDropdown(): void {
        this.isOpen = !this.isOpen;
    }

    isSelected(value: string): boolean {
        return this.selectedValues.includes(value);
    }

    toggleSelection(text: string, value: string): void {
        const index = this.selectedValues.indexOf(value);
        if (index === -1) {
            this.selectedValues.push(value);
        } else {
            this.selectedValues.splice(index, 1);
        }
    }

    showHideSubject() {
        this.isShowSubject = !this.isShowSubject;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["alertParameters"]) {
            this.storedDataFromLS = this._storageService.getData<SearchParamsModel>('advancedSearchFormParams') ?? new SearchParamsModel();
            this.intialiseEmailForm();
            this.getAllUsers();
            this.selectAll = false;
            this.isOpen = false;
            if (this.response) {
                this.response.status = "";
                this.response.data = "";
            }
            this.selectedValues = [];
            this.emailForm.get("bcc")?.valueChanges.subscribe(value => {
                this.updateManuallyBCCEnteredEmails(value);
            });
            if (this.alertParameters.scheduleId > 0) {
                this.getScheduleDetails(this.alertParameters.scheduleId);
            }

        }
    }
    get bccAddress() {
        return this.emailForm.get('bcc');
    }

    intialiseEmailForm() {
        this.emailForm = this.formBuilder.group({
            bcc: ["", []],
            cc: ["", []],
            closing: [""],
            subject: [""],
            message: ["", [Validators.required, Validators.maxLength(480)]],
            telephone: [""]
        });
    }

    private getScheduleDetails(scheduleId: number) {
        const schedule$ = (scheduleId > 0 ? this._scheduleDataService.getSchedule(scheduleId) : of(null));
        const currentUser$ = this._userDataService.getCurrentUser();

        const param = this.createScheduleParameters();
        param.truckerCode = this.alertParameters.truckerId;
        param.whetherFilterIfTruckerIdIsNotAvailable = this.alertParameters.isRequestFromSendTextAlertForm ? false : true;

        const truckerRequest$ = this.alertParameters.locCode != "" ? this._scheduleDataService.getFilteredTruckers(param) : of(null);
        this.truckerArray = [];
        forkJoin([schedule$, currentUser$]).subscribe({
            next: ([schedule, currentUser]) => {
                this.schedule = schedule;
                {
                    let subject = "Scoular Alert: ";
                    if (this.schedule != null && this.schedule?.scheduleBeginDate != null) {
                        subject = subject + this.formatDate(this.schedule.scheduleBeginDate);
                    }
                    else {
                        subject = subject + "Period between " + this.convertDateString(this.alertParameters.periodStartDate) + " and " + this.convertDateString(this.alertParameters.periodEndDate);

                    }
                    this.emailForm.patchValue({ subject: subject });
                    this.emailForm.patchValue({ closing: "Thanks, \n" + currentUser.userName });
                }
                forkJoin([truckerRequest$]).subscribe({
                    next: ([truckerResponse]) => {

                        const processedData = this.processTruckerAndContactsInfo(truckerResponse);
                        this.truckerArray = processedData.map((trucker: AlertTruckerFilteredTruckersContactInfo) => ({
                            customerId: trucker.customerId,
                            truckerName: trucker.truckerName,
                            mainContact: trucker.mainContact,
                            phone: trucker.phone,
                            email: trucker.email,
                            isTruckerSelected: false,
                            whetherToConsiderEmail: trucker.email !== "",
                            isTruckerAdded: false,
                            whetherToConsiderPhone: trucker.phone !== ""
                        }));
                    },
                    error: (err) => {
                        this.errorMessage = err;
                    },
                });
            },
            error: (err) => {
                this.errorMessage = err;

            },
        });
    }

    private createScheduleParameters() {
        var param = new ScheduleParameters();
        param.locCode = this.alertParameters.selectedLocCodeInFilter;
        param.locationType = this.alertParameters.locationType;
        param.periodStartDate = this.alertParameters.periodStartDate;
        param.periodEndDate = this.alertParameters.periodEndDate;
        param.shipThroughDate = this.alertParameters.periodEndDate;
        return param;
    }

    convertDateString(dateInput: string): string {
        const [year, month, day] = dateInput.split('-');
        return `${month}/${day}/${year}`;
    }

    processTruckerAndContactsInfo(data: FilteredTruckersInfo[]): AlertTruckerFilteredTruckersContactInfo[] {
        const uniqueContactsMap = new Map<string, any>();
        data.forEach(trucker => {
            if (trucker?.contacts?.length > 0) {
                trucker.contacts.forEach(contact => {
                    let phone = trucker.telephone1 ?? trucker.telephone2;
                    if (contact.isPhone1TextEnabled == true && contact.isPhone2TextEnabled == true) {
                        if (contact.phone1 || contact.phone2) {
                            phone = [contact.phone1, contact.phone2].filter(Boolean).join(', ');
                        }
                    }
                    else if (contact.isPhone1TextEnabled == true) {
                        phone = contact.phone1;
                    }
                    else if (contact.isPhone2TextEnabled == true) {
                        phone = contact.phone2;
                    }

                    const contactInfo = {
                        customerId: trucker.customerId,
                        truckerName: trucker.customerName,
                        mainContact: contact.contactName,
                        phone: phone,
                        email: contact.email != '' ? contact.email : trucker.email
                    };
                    const contactIdentifier = `${contactInfo.truckerName}-${contactInfo.mainContact}-${contactInfo.email}`;

                    // Add contact to the map if it doesn't exist
                    if (!uniqueContactsMap.has(contactIdentifier)) {
                        uniqueContactsMap.set(contactIdentifier, contactInfo);
                    }
                });

            } else {
                const contactInfo = {
                    customerId: trucker.customerId,
                    truckerName: trucker.customerName,
                    mainContact: "-",
                    phone: trucker.telephone1 || trucker.telephone2,
                    email: trucker.email
                };
                const contactIdentifier = `${contactInfo.truckerName}-${contactInfo.mainContact}-${contactInfo.email}`;

                // Add contact to the map if it doesn't exist
                if (!uniqueContactsMap.has(contactIdentifier)) {
                    uniqueContactsMap.set(contactIdentifier, contactInfo);
                }
            }
        });
        const _tempSelectedTruckerInfoContactList = Array.from(uniqueContactsMap.values());
        return _tempSelectedTruckerInfoContactList.sort((a, b) => {
            const nameComparison = a.truckerName.localeCompare(b.truckerName);
            if (nameComparison !== 0) {
                return nameComparison;
            }
            return a.mainContact.localeCompare(b.mainContact);
        });
    }

    formatDate(inputDate: string): string {
        const date = new Date(inputDate);
        const monthName = this.getMonthName(date);
        return `Week of ${monthName} ${date.getDate()}`;
    }

    getMonthName(date: Date): string {
        const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        const monthIndex = date.getMonth();

        // Return the month name
        return monthNames[monthIndex];
    }

    selectAllInBCc(event: Event) {
        const isChecked = (event.target as HTMLInputElement).checked;
        this.truckerArray.forEach(element => {
            element.isTruckerSelected = isChecked;
        });

        const selectedUserPhone = [
            ...new Set(
                this.truckerArray
                    .filter(x => x.isTruckerSelected === true && x.whetherToConsiderPhone === true)
                    .map(x => x.phone?.trim())
            ),
        ];

        const selectedUserEmail = [
            ...new Set(
                this.truckerArray
                    .filter(x => x.isTruckerSelected === true && x.whetherToConsiderEmail === true)
                    .map(x => x.email?.trim())
            ),
        ];

        this.truckerArray.forEach(element => {
            element.whetherToConsiderEmail = element.email !== "",
                element.whetherToConsiderPhone = element.phone !== ""
        });


        this.emailForm.patchValue({ telephone: selectedUserPhone?.join(";") ?? "", bcc: selectedUserEmail?.join(";") ?? "" });
    }

    resetTheEmailAndPhone(trucker) {
        const selectedUserPhone = [
            ...new Set(
                this.truckerArray
                    .filter(x => x.isTruckerSelected === true && x.whetherToConsiderPhone === true)
                    .map(x => x.phone?.trim())
            ),
        ];

        const selectedUserEmail = [
            ...new Set(
                this.truckerArray
                    .filter(x => x.isTruckerSelected === true && x.whetherToConsiderEmail === true)
                    .map(x => x.email?.trim())
            ),
        ];

        if (trucker.whetherToConsiderEmail == false && trucker.whetherToConsiderPhone == false) {
            trucker.isTruckerSelected = false;
        }

        if (this.truckerArray.filter(x => x.isTruckerSelected === false)?.length > 0) {
            this.selectAll = false;
        }

        this.emailForm.patchValue({ telephone: selectedUserPhone?.join(";") ?? "", bcc: selectedUserEmail?.join(";") ?? "" });
    }


    selectUserInBCc(event: Event, trucker: AlertTruckerFilteredTruckersContactInfo) {
        const isChecked = (event.target as HTMLInputElement).checked;
        if (!isChecked) {
            const lastSelectedUserEmail = trucker.email;
            const bccUsersFromField = this.emailForm.get('bcc').value;
            let bccUsersValue;
            if (bccUsersFromField.includes(";")) {
                const bccUsersArray = bccUsersFromField?.split(";");
                bccUsersValue = bccUsersArray?.filter(email => email != lastSelectedUserEmail).join(";");
            }
            else {
                bccUsersValue = bccUsersFromField.replace(lastSelectedUserEmail, "")
                    .replace(new RegExp(`^${lastSelectedUserEmail};?`), "")
                    .replace(new RegExp(`;?${lastSelectedUserEmail}$`), "");
            }
            this.emailForm.patchValue({ bcc: bccUsersValue });

            const selectedUserPhone = [
                ...new Set(
                    this.truckerArray
                        .filter(x => x.isTruckerSelected === true && x.whetherToConsiderPhone === true)
                        .map(x => x.phone?.trim())
                ),
            ];

            this.emailForm.patchValue({ telephone: selectedUserPhone.join(";") });

        }
        else {
            if (this.truckerArray) {
                const selectedUserEmails = this.truckerArray.filter(x => x.isTruckerSelected == true && x.whetherToConsiderEmail == true).map(x => x.email);
                this.manuallyBCCEnteredEmails = this.manuallyBCCEnteredEmails.filter(email => !this.truckerArray.some(trucker => trucker.email == email));
                const combinedEmails = Array.from(new Set([...selectedUserEmails, ...this.manuallyBCCEnteredEmails]));
                this.emailForm.patchValue({ bcc: combinedEmails?.join(";") });

                const selectedUserPhone = this.truckerArray.filter(x => x.isTruckerSelected == true && x.whetherToConsiderPhone == true).map(x => x.phone?.trim());
                this.emailForm.patchValue({ telephone: selectedUserPhone?.join(";") });

                this.truckerArray.forEach(y => {
                    y.isTruckerAdded = y.isTruckerSelected
                });

                trucker.whetherToConsiderEmail = trucker.email !== "";
                trucker.whetherToConsiderPhone = trucker.phone !== "";
            }
        }
    }

    getSelectedTruckerCount() {
        const count = this.truckerArray?.filter(x => x.isTruckerSelected == true)?.length;
        return count === 0 ? "No truckers selected" : count + " truckers selected"
    }

    updateManuallyBCCEnteredEmails(value: string): void {
        value = value.includes(";") ? value : value.toString() + ";";//to handle the case when only one email address is there.
        const emailArray = value.split(';').map(email => email.trim()).filter(email => email !== '');
        this.manuallyBCCEnteredEmails = emailArray.filter(email => !this.userArray.some(user => user.userEmail == email));

        const hasError = emailArray.some((email) =>
            Validators.email(new FormControl(email?.trim()))
        );
        this.bccValid = hasError ? false : true;
    }

    sendEmailAndTextMessage(): void {

        const bcc = this.emailForm.get("bcc")?.value;
        const cc = this.emailForm.get("cc")?.value;
        const subject = this.emailForm.get("subject").value;
        const message = this.emailForm.get("message").value;
        const closing = this.emailForm.get("closing").value;
        const telephone = this.emailForm.get("telephone").value;

        if (message == "") {
            this.response = {
                data: "Please enter the message.",
                status: "Error",
            };
            return;
        }

        if (bcc?.length > 0 || cc?.length > 0) {
            if (subject == "") {
                this.response = {
                    data: "Please enter the subject of the email.",
                    status: "Error",
                };
                return;
            }

            if (closing == "") {
                this.response = {
                    data: "Please enter the closing note.",
                    status: "Error",
                };
                return;
            }
        }

        if (bcc?.length == 0 && cc?.length == 0 && telephone == "") {
            this.response = {
                data: "Please enter/ select atleast one telephone number or a valid email address",
                status: "Error",
            };
            return;
        }

        if (this.emailForm.valid) {
            const messageInfo = {
                From: "",
                To: "",
                CC: cc,
                BCC: bcc,
                Subject: subject,
                Body: message,
                Telephone: this.emailForm.get("telephone")?.value,
                Attachment: "",
                ClosingNote: closing,
                ProcessName: "AlertTruckerForm",
            };

            messageInfo.CC = messageInfo.CC?.replace(/,/g, ';');
            messageInfo.BCC = messageInfo.BCC?.replace(/,/g, ';');
            this._messageService.sendEmailAndTextMessage(messageInfo).subscribe({
                next: (data) => {
                    this.response = {
                        data: data,
                        status: data.toLowerCase().indexOf("failed") > -1 ? "Error" : "Success",
                    };
                    if (data.toLowerCase().indexOf("success") > -1) {
                        setTimeout(() => {
                            this.closeButton.nativeElement.click();
                        }, 3000);
                    }

                },
                error: (err) => {
                    this.response = {
                        data: "Error occurred, please try again",
                        status: "Error",
                    };
                },
            });
        }
        else {
            this.response = {
                data: "Please enter valid details.",
                status: "Error",
            };
        }
    }
}
